import { createFeatureSelector } from '@ngrx/store';
import { BiEngineState } from '../reducers';

export const biChartEngineFeatureSelector = createFeatureSelector<BiEngineState>('bi-chart-engine');
